// Bellek boyutunu formatla
export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Çalışma süresini formatla
export const formatUptime = (seconds: number): string => {
  if (seconds < 60) {
    return `${Math.floor(seconds)}s`;
  }
  
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}m`;
  }
  
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}h ${minutes % 60}m`;
  }
  
  const days = Math.floor(hours / 24);
  return `${days}d ${hours % 24}h`;
};

// CPU yüzdesini formatla
export const formatCpuPercent = (cpu: number): string => {
  return `${cpu.toFixed(1)}%`;
};

// Tarih formatla
export const formatDate = (date: Date | string): string => {
  const d = new Date(date);
  return d.toLocaleString('tr-TR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

// Durum rengini belirle
export const getStatusColor = (status: string): 'success' | 'error' | 'warning' | 'default' => {
  switch (status.toLowerCase()) {
    case 'online':
    case 'running':
      return 'success';
    case 'stopped':
    case 'stopping':
      return 'error';
    case 'errored':
    case 'error':
      return 'error';
    case 'launching':
    case 'waiting':
      return 'warning';
    default:
      return 'default';
  }
};

// Durum metnini Türkçe'ye çevir
export const getStatusText = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'online':
      return 'Çalışıyor';
    case 'stopped':
      return 'Durduruldu';
    case 'errored':
      return 'Hata';
    case 'launching':
      return 'Başlatılıyor';
    case 'stopping':
      return 'Durduruluyor';
    case 'waiting':
      return 'Bekliyor';
    default:
      return status;
  }
};
